import { Box, Checkbox, Text } from "@prismicio/editor-ui"

import { useEditorConfig } from "../../../../EditorConfig"
import { useSelectionManager } from "../../../SelectionManager"
import { useMediaLibrary } from "../MediaLibraryContext"
import { AssetCount } from "./AssetCount"
import { AssetTypeFilter, TagsFilter, UploaderFilter } from "./filters"

export function Toolbar() {
  const { media, mediaTotal } = useMediaLibrary()
  const selectionManager = useSelectionManager()

  const config = useEditorConfig()
  const showUploaderFilter =
    config.mediaLibrary && config.mediaLibraryUploadersEnabled

  return (
    <Box alignItems="center" gap={16}>
      {selectionManager.isSelectAllEnabled && (
        <Checkbox
          onCheckedChange={selectionManager.toggleSelectAll}
          checked={selectionManager.selectedCount > 0}
          indeterminate={selectionManager.selectedCount !== mediaTotal}
          onClick={(event) => event.stopPropagation()}
          disabled={media.length === 0}
        />
      )}
      {media.length !== 0 && <AssetCount count={mediaTotal} />}
      <Box gap={8} alignItems="center">
        <Text>Filter:</Text>
        <AssetTypeFilter />
        {showUploaderFilter && <UploaderFilter />}
        <TagsFilter />
      </Box>
    </Box>
  )
}
